<template>
    <div class="container-fluid">
        <nav aria-label="breadcrumb" class="col-sm-12">
            <ol class="breadcrumb bg-orange mb-0">
                <li class="breadcrumb-item"><a href="#" class="text-white"><i class="ri-home-4-line mr-1 float-left" style="font-size: 20px;"></i>Fast</a></li>
                <li class="breadcrumb-item active text-white" aria-current="page">Game Library</li>
            </ol>
        </nav>    
        <br>
        <b-row class="row justify-content-center">
            <b-col sm="12" style="padding-left: 3%">
                <h4 class="mt-2 mb-3">Game Library</h4>
            </b-col>
            <br>
            <div class="row justify-content-between col-12">
                <div class="col-sm-12 col-md-12">
                    <div class="card dataTables_filter">
                        <div class="card-body">
                        <form class="mr-3 position-relative row">
                            <div class="form-group mx-2 col-md-5">
                                <label for="search">Search Game:</label>
                                <input type="text" id="inputSearch" class="form-control" placeholder="Game Name" v-model="search">
                            </div>

                            <div class="form-group mx-2 col-md-3">
                                <label for="sort">Sort</label>
                                <select id="mode" class="form-control" @change="codeOrder($event)">
                                    <option value="date" selected>Release Date</option>
                                        <option value="alphabet">Alphabetically</option>
                                </select>
                            </div>

                            <div class="form-group mx-2 col-md-2">
                                <label for="mode">Tags</label>
                                <select class="form-control" id="sort" @change="tag($event)" >
                                        <option value ="all" selected>Tags</option>
                                        <option value="popular">Popular</option>
                                </select>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>          
            
            <div v-for="item in filteredGames" v-bind:key="item.id " class="games-card w-80">
            <b-col class="card-group d-flex align-items-center">
                <b-card no-body class="iq-mb-3 blur-shadow p-4 shadow-showcase " >
                    <b-row no-gutters>
                        <b-col md="3"> 
                            <!-- <div v-for="code in upcoming_games" v-bind:key="code.id" >
                                <h6>{{code}}</h6>
                                <h6>{{item.code}}</h6>
                                <h6 v-if= "code== item.code" v-show = "!upcoming">Upcoming</h6>
                                <h6 v-else v-show = "upcoming">Upcoming</h6>  
                            </div> -->
                            <b-card-img :src="getGameImg(item.code)"></b-card-img>
                        </b-col>
                        <b-col sm="1"></b-col>
                        <b-col md="8" >
                            <b-card-body :title="item.name">
                                <b-card-text class="mt-4">
                                     <b-row>
                                        <b-col cols="6"> 
                                            <b-form-group label-class="font-weight-bold" label-cols="5" label-cols-lg="6" label-size="sm" label="Game Code" >
                                                {{item.code}}
                                            </b-form-group>
                                        </b-col>
                                         <b-col cols="6"> 
                                            <b-form-group label-class="font-weight-bold" label-cols="4" label-cols-lg="7" label-size="sm" label="Release Date" >
                                            {{item.releaseDate}}
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                         <b-col cols="6"> 
                                            <b-form-group label-class="font-weight-bold" label-cols="5" label-cols-lg="6" label-size="sm" label="RTP" >
                                                {{item.rtp}}
                                            </b-form-group>
                                        </b-col>
                                         <b-col cols="6"> 
                                            <b-form-group label-class="font-weight-bold" label-cols="4" label-cols-lg="7" label-size="sm" label="Player Demographic:" >
                                            All
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6"> 
                                            <!-- <b-form-group label-cols="4" label-cols-lg="6" label-size="sm" label="Symbols" >
                                                {{item.max_multiplier}}
                                            </b-form-group> -->
                                            <div v-for="code in symbol" v-bind:key="code.id" >
                                                <b-form-group label-class="font-weight-bold" v-if="code.game_code === item.code" label-cols="4" label-cols-lg="6" label-size="sm" label="Symbols" >
                                                    {{code.symbol}}
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                        <b-col cols="6"> 
                                            <b-form-group label-class="font-weight-bold" label-cols="4" label-cols-lg="7" label-size="sm" label="Player Skill Level:" >
                                            All
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6">   
                                            <div v-for="code in setting" v-bind:key="code.id" >                           
                                                <b-form-group label-class="font-weight-bold" v-if="code.game_code === item.code" label-cols="4" label-cols-lg="6" label-size="sm" label="Minimum Total Bet" >
                                                {{code.default_domination}}
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                       
                                    </b-row>
                                    <!-- <b-row>
                                       <b-col cols="6">                              
                                            <b-form-group label-class="font-weight-bold" label-cols="4" label-cols-lg="6" label-size="sm" label="Maximum Total Bet" >
                                               {{item.line}}
                                            </b-form-group>
                                        </b-col>
                                    </b-row> -->
                                </b-card-text>
                                <b-button pill variant="orange" v-bind:href="'/fast/game-detail?code='+ item.code" class="mt-2 mr-1 text-white float-right">View Detail</b-button>
                                <!-- <a href="#" :data-title="item.name" :data-url="`/doc-viewer/files/demo.pdf`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal>
                                    <b-button pill variant="outline-orange" class="mt-2 mr-1 text-black float-right" >Game Overview</b-button>
                                </a>     -->
                                <b-button pill variant="outline-orange" v-bind:href="'https://play.nextspin.com/games/game.php?game='+item.code+'&language=en_US'" target="_blank" class="mt-2 mr-1 float-right" >Play Demo Game</b-button>
                                
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            </div>
        </b-row>                         
    </div>
</template>
<style>

    .games-card .card{
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
    }

    .games-card .card:hover {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
</style>
<script>

import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import VueAxios from 'vue-axios';

const URL = require("../../../../config");
Vue.use(VueAxios, axios, moment)

export default {
    name:'FastLibrary',
    data() {
        return {
            list: [],
            setting:[],
            orderby_code:[],
            orderby_date:[],
            popular_game:[],
            symbol:[],
            upcoming: false,
            upcoming_games: [],
            totalBet: undefined,
            search: '',
        }
    },
    async mounted() {
        let response = await Vue.axios.get( URL.api.URL + '/api/fastlib', { params: { m: this.$route.meta.uid } });
        this.list = response.data.fast_game
        this.symbol = response.data.symbol
        this.setting = response.data.game_setting
        console.log(this.setting)

        // this.orderby_date = response.data.all_game
        // this.orderby_code = response.data.order_by_code
        // this.all_game = response.data.all_game
        // this.popular_game = response.data.popular_game
        

        /*upcoming games checking */
        var currentDate = new Date().toISOString();
        this.list.forEach(element => {
            var releaseDate = new Date(element.releaseDate).toISOString();
            var code = element.code;
            if(moment(releaseDate).isAfter(moment(currentDate))) {
               this.upcoming_games.push(code)
            }
            else {
              return false 
            }              
        });
    },
    methods:{
        openPDF() {
            window.open("../../../assets/PDF/Lucky-Grace-and-Charm-1-1.pdf", '_blank')
        },
        codeOrder(event) {
            const order = event.target.value;
            if (order == "date") {
                this.list = this.orderby_date                
            } 
            else {
                this.list = this.orderby_code   
            }            
        },
        tag(event) {
            const tag = event.target.value;
            if(tag == "popular") {
                this.list = this.popular_game       
            }
            
            if (tag == "all") {
                this.list = this.all_game
            }            
        },
        getGameImg(gameCode) {
            try {
                return require('../../../../static/images/gamepic/'+gameCode+'_350x350.jpg');
            } catch (error) {
                return require('../../../assets/images/NS_Black_cleaned.svg');
            }
        }
    },
    computed:{
        filteredGames: function() {
            return this.list.filter((item) => {
                return item.name.toLowerCase().match(this.search.toLowerCase());
            })
        },
    }
}
</script>